import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the widgetMultipleChoiceQuestions state domain
 */

const selectWidgetMultipleChoiceQuestionsDomain = (state) =>
  state.get("widgetMultipleChoiceQuestions", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectWidgetMultipleChoiceQuestionsDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectListMultipleChoiceQuestions = () =>
  createSelector(selectWidgetMultipleChoiceQuestionsDomain, (state) =>
    state.get("listMultipleChoiceQuestions")
  )

/**
 * Default selector used by WidgetMultipleOptions
 */

const makeSelectWidgetMultipleChoiceQuestions = () =>
  createSelector(selectWidgetMultipleChoiceQuestionsDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetMultipleChoiceQuestions
export { selectWidgetMultipleChoiceQuestionsDomain }
